// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4aa9137d","455":"17451058","488":"a37d4475"}[chunkId] + ".chunk.js";
};